import { render } from "./BasicModal.vue?vue&type=template&id=7da32372&scoped=true"
import script from "./BasicModal.vue?vue&type=script&lang=js"
export * from "./BasicModal.vue?vue&type=script&lang=js"

import "./BasicModal.vue?vue&type=style&index=0&id=7da32372&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da32372"]])

export default __exports__